module.exports = __webpack_public_path__ + "img/street_ico.34190b8a.svg";